export const CAMERA_GRAPH_DIAGNOSTICS = {
    cacheLimit: 128,
    markerRadius: 0.22,
    clipRadius: 0.7,
    color: '#8296a6',
    activeColor: '#ffd479',
    targetColor: '#9bb9b0',
    fade: {
        nearDistance: 0.5,
        farDistance: 1.5,
        nearOpacity: 0,
        insideOpacity: 0,
    },
};
